import { MdHistory } from "react-icons/md";
import { FaBtc, FaUserTie, FaEdit, FaPhone } from "react-icons/fa";
import { AiOutlineFileText } from "react-icons/ai";
import { FormattedMessage } from "react-intl";
import { PiGitPullRequestLight, PiPersonArmsSpreadFill } from "react-icons/pi";
import { GrMoney } from "react-icons/gr";

import { type AppTabProps } from "@lib/components/AppComponents/AppTabs";
import { SharedContextProps } from "@lib/types";
import {
  SharedWalletAddressBillingList,
  SharedBlockchainPaymentList,
  SharedBlockchainPaymentRequestList,
  SharedCashPaymentHistory,
  SharedInvoices,
  SharedCustomerLeads,
  SharedManagers,
  SharedWalletAddressSendByteList,
  SharedWalletListSendByte,
  SharedWalletAddressAIList,
  SharedTftSalesLeads,
  SharedTftSalesCalls,
  SharedCustomerVoipConfigs,
} from "@app/shared";
import CustomerDetailEdit from "./CustomerDetailEdit";

export const getCustomerDetailTabs = (): AppTabProps<SharedContextProps>[] => [
  {
    key: "edit",
    Title: <FormattedMessage id={"customer.tabs.edit"} />,
    Icon: <FaEdit />,
    Component: CustomerDetailEdit,
  },
  {
    key: "tftSalesLeads",
    Title: <FormattedMessage id={"customer.tabs.tftSalesLeads"} />,
    Icon: <PiPersonArmsSpreadFill />,
    Component: SharedTftSalesLeads,
  },
  {
    key: "tftSalesCalls",
    Title: <FormattedMessage id={"customer.tabs.tftSalesCalls"} />,
    Icon: <MdHistory />,
    Component: SharedTftSalesCalls,
  },
  {
    key: "invoice",
    Title: <FormattedMessage id={"customer.tabs.invoice"} />,
    Icon: <AiOutlineFileText />,
    Component: SharedInvoices,
  },
  // {
  //   key: "order",
  //   Title: <FormattedMessage id={"customer.tabs.order"} />,
  //   Icon: <FaFileInvoiceDollar />,
  //   Component: OrderTab,
  // },
  {
    key: "walletsSendByte",
    Title: <FormattedMessage id={"customer.tabs.walletsSendByte"} />,
    Icon: <FaBtc />,
    Component: SharedWalletListSendByte,
  },
  {
    key: "walletAccountsSendByte",
    Title: <FormattedMessage id={"customer.tabs.walletAccountsSendByte"} />,
    Icon: <FaBtc />,
    Component: SharedWalletAddressSendByteList,
  },
  {
    key: "walletAccountsAI",
    Title: <FormattedMessage id={"customer.tabs.walletAccountsAI"} />,
    Icon: <FaBtc />,
    Component: SharedWalletAddressAIList,
  },
  {
    key: "walletAccounts",
    Title: <FormattedMessage id={"customer.tabs.walletAccounts"} />,
    Icon: <FaBtc />,
    Component: SharedWalletAddressBillingList,
  },
  {
    key: "blockchainPaymentRequests",
    Title: <FormattedMessage id={"customer.tabs.blockchainPaymentRequests"} />,
    Icon: <PiGitPullRequestLight />,
    Component: SharedBlockchainPaymentRequestList,
  },
  {
    key: "blockchainPayments",
    Title: <FormattedMessage id={"customer.tabs.blockchainPayments"} />,
    Icon: <MdHistory />,
    Component: SharedBlockchainPaymentList,
  },
  {
    key: "cashPaymentHistory",
    Title: <FormattedMessage id={"customer.tabs.cashPaymentHistory"} />,
    Icon: <GrMoney />,
    Component: SharedCashPaymentHistory,
  },
  {
    key: "customerLeads",
    Title: <FormattedMessage id={"customer.tabs.customerLeads"} />,
    Icon: <PiPersonArmsSpreadFill />,
    Component: SharedCustomerLeads,
  },
  {
    key: "manager",
    Title: <FormattedMessage id={"customer.tabs.manager"} />,
    Icon: <FaUserTie />,
    Component: SharedManagers,
  },
  {
    key: "customerVoipConfigs",
    Title: <FormattedMessage id={"sidebar.customerVoipConfigs"} />,
    Icon: <FaPhone />,
    Component: SharedCustomerVoipConfigs,
  },
];
